<style scoped lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/report/page/sale_order_out_record" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('kehumingcheng')">
            <el-select collapse-tags v-model="yt.conditions.wmsCustomerIds" filterable>
              <el-option v-for="(item, index) in customerList" :key="index" :label="item.customerCodeName" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('xiaoshoudingdanhao')">
            <el-input v-model="yt.conditions.soNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_cross_select multiple :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="yt.conditions.materialId"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('chukuriqi')">
            <yi_time_input type="daterange" :format="'yyyy-MM-dd'" :start.sync="yt.conditions.createTimeStart" :end.sync="yt.conditions.createTimeEnd"> </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1, null, afterReq)" type="primary" plain>
              {{ $t('sousuo') }}
            </el-button>
            <el-button
              @click="
                yt.clear(
                  {
                    startDateStart: dayjs()
                      .startOf('month')
                      .valueOf(),
                    endDateEnd: dayjs()
                      .endOf('month')
                      .valueOf()
                  },
                  null,
                  afterReq
                )
              "
            >
              {{ $t('chongzhi') }}
            </el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" :loading="exportLoading" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #footer>
        <!-- 这里可以在底部填写东西 -->
        <div style="display: flex;flex-wrap: nowrap;justify-content: flex-start;align-items: center;">
          <div style="font-size: 17px;font-weight: bold">
            {{ $t('hejishifahuozhi') }}
          </div>
          <div style="margin-left: 8px;color: #606266;font-size: 14px">
            <span style="margin-left: 8px">{{ sumAll == NaN || sumAll == null || sumAll == undefined ? 0 : sumAll.toFixed(3) }}</span>
          </div>
        </div>
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_report_sale_order_out_record_table',

  data() {
    return {
      exportLoading: false,
      openingInventorySum: 0,
      warehousingSum: 0,
      outboundSum: 0,
      endingInventorySum: 0,
      list: [],
      totalExtend: {},
      sumAll: 0,
      customerList: [],
      columns: [
        {
          label: 'chanpinbianma',
          prop: 'materialCode',
          width: 130
        },
        {
          label: 'chanpinmingcheng',
          prop: 'materialName',
          width: 130
        },
        {
          label: 'guige',
          prop: 'materialSpec',
          width: 130
        },
        {
          label: 'xiaoshoudingdanhao',
          prop: 'soNo'
        },
        {
          label: 'dingdanxing',
          prop: 'serialNo',
          width: 130
        },
        {
          label: 'kehumingcheng',
          prop: 'customerName',
          width: 130
        },
        {
          label: 'dingdanshuliang',
          prop: 'saleQuantity',
          width: 130
        },
        {
          label: 'shifashuliang',
          prop: 'totalTransactionQuantity',
          width: 130
        },
        {
          label: 'weifashuliang',
          prop: 'unissuedQuantity',
          width: 130
        },
        {
          label: 'chukudanhao',
          prop: 'outOrderNo'
        },
        {
          label: 'danweihuozhi',
          prop: 'price',
          width: 130
        },
        {
          label: 'shifahuozhi',
          prop: 'totalActualAmount',
          width: 130
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.getCustomerList();
      this.yt.get(1, null, this.afterReq);
    }, 300);
  },
  methods: {
    // 获取客户编码、名称
    async getCustomerList() {
      return await this.http
        .get(
          '/web/wms/customer/page?' +
            this.qs.stringify({
              pageNum: 1,
              pageSize: 999
              // orderBy: 'sort',
            })
        )
        .then(response => {
          this.customerList = response.data.rows || [];
          for (let i = 0; i < this.customerList.length; i++) {
            const customerCodeName = this.customerList[i]['code'] + '/' + this.customerList[i]['name'];
            this.$set(this.customerList[i], 'customerCodeName', customerCodeName);
          }
          console.log('this.customerList', this.customerList);
        });
    },
    afterReq(results) {
      this.sumAll = 0;
      for (let i = 0; i < results.data.rows.length; i++) {
        this.sumAll += results.data.rows[i].totalActualAmount;
      }
      return results;
    },

    exportExcel() {
      this.exportLoading = true;
      let params = this.yt.conditions;
      return this.http
        .get('/web/report/export/sale_order_out_record', {
          params
        })
        .then(res => {
          this.exportLoading = false;
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
        })
        .catch(error => {
          this.$message.error(this.$t(error));
          this.exportLoading = false;
        });
    }
  }
};
</script>
